<template>
  <div class="custom-spu-designer-content">
    <div class="design-top">
      <div class="logo-icon">
        <img src="../icon/console_logo.svg"
             class="logo"
             @click="() => { route.path !== '/' ? router.push('/') : '' }">
      </div>
      <div class="back-icon">
        <div class="back"
             @click="() => { router.go(-1) }">
          <img src="../icon/back.png">
          <span>{{ $t('CustomSpus.CustomSpuDesigner.back') }}</span>
        </div>
      </div>
      <div :class="['user', !isLogin ? '' : 'user-login']">
        <a-button v-if="!isLogin"
                  class="login-btn"
                  @click="login">{{ $t('CustomSpus.CustomSpuDesigner.loginRegister') }}</a-button>
        <component :is="'FlashbaseUserProfileControl'"
                   v-else>
          <template #design>
            <a-menu-item @click="designClick">
              <template #icon>
                <highlight-outlined />
              </template>
              {{ $t('CustomSpus.CustomSpuDesigner.goDesign') }}
            </a-menu-item>
          </template>
        </component>
      </div>
    </div>
    <div class="designer">
      <a-tabs v-model:activeKey="activeKey"
              tab-bar-gutter="0">
        <template #renderTabBar>
          <div class="tab-pane">
            <div :class="['tab', activeKey === '1' ? 'selected' : 'select', tutorialSteps === 1 ? 'tutorial-show' : '']"
                 @click="judgmentSelectProduct">
              {{ $t('CustomSpus.CustomSpuDesigner.selectProduct') }}
            </div>
            <div :class="['tab', activeKey === '2' ? 'selected' : 'select', tutorialSteps === 2 ? 'tutorial-show' : tutorialSteps === 3 ? 'tutorial-show' : '']"
                 @click="activeKey = '2'">
              {{ $t('CustomSpus.CustomSpuDesigner.myDesigns') }}
            </div>
          </div>
        </template>
        <a-tab-pane key="1"
                    class="tutorial-show"
                    :tab="$t('CustomSpus.CustomSpuDesigner.selectProduct')">
          <ul v-if="activeKey === '1'"
              class="product-box">
            <li v-for="(item, index) in productArray"
                :key="index">
              <p class="product-category">{{ item.name }}</p>
              <div class="product-list">
                <a-popover v-for="(itm, j) in item.list"
                           :key="j"
                           :title="$t('CustomSpus.CustomSpuDesigner.productInfo')"
                           trigger="hover"
                           class="product-item"
                           placement="right"
                           @click="productItemClick(itm)">
                  <img class="product-list-img"
                       :src="itm.image" />
                  <template #content>
                    <div class="itemDetail">
                      <img :src="itm.image" />
                      <p class="title">{{ itm.name }}</p>
                      <div class="detail-txt">
                        <span>{{ $t('CustomSpus.CustomSpuDesigner.priceStartPrefix') }}{{ itm.price }}{{
                          $t('CustomSpus.CustomSpuDesigner.priceStartSuffix') }}</span>
                        <span>{{ $t('CustomSpus.CustomSpuDesigner.soldCountPrefix') }}{{ itm.sale_count }}</span>
                      </div>
                      <div class="detail-desc">
                        <p v-if="temporaryMaterial">{{ temporaryMaterial }}</p>
                        <p v-if="itm.deliver">{{ $t('CustomSpus.CustomSpuDesigner.deliveryTimePrefix') }}{{ itm.deliver
                        }}{{ $t('CustomSpus.CustomSpuDesigner.deliveryTimeSuffix') }}</p>
                        <p>{{ itm.desc }}</p>
                        <!-- <span v-if="temporarySize">尺码：{{ temporarySize }}</span> -->
                      </div>
                    </div>
                  </template>
                </a-popover>
              </div>
            </li>
          </ul>
        </a-tab-pane>
        <a-tab-pane key="2"
                    :tab="$t('CustomSpus.CustomSpuDesigner.myDesigns')">
          <div class="myDesign">
            <div
                 :class="['asideMenu', tutorialSteps === 2 ? 'tutorial-show' : tutorialSteps === 3 ? 'tutorial-show' : '']">
              <ul>
                <li :class="[{ active: currentActive === 'design' }]"
                    @click="currentActive = 'design'">
                  <img v-if="currentActive === 'design'"
                       src="../icon/design-selected.png" />
                  <img v-else
                       src="../icon/design-icon.png" />
                  <p :class="currentActive === 'design' ? 'aside-title-selected' : ''">{{
                    $t('CustomSpus.CustomSpuDesigner.product') }}</p>
                </li>
                <li :class="[{ active: currentActive == 'material' }]"
                    @click="currentActive = 'material'">
                  <img v-if="currentActive === 'material'"
                       src="../icon/material-selected.png" />
                  <img v-else
                       src="../icon/material.png" />
                  <p :class="currentActive === 'material' ? 'aside-title-selected' : ''">{{
                    $t('CustomSpus.CustomSpuDesigner.gallery') }}</p>
                </li>
                <li :class="[{ active: currentActive == 'upload' }]"
                    @click=" currentActive = 'upload'">
                  <img v-if="currentActive === 'upload'"
                       src="../icon/upload-selected.png" />
                  <img v-else
                       src="../icon/upload.png" />
                  <p :class="currentActive === 'upload' ? 'aside-title-selected' : ''">{{
                    $t('CustomSpus.CustomSpuDesigner.upload') }}</p>
                </li>
                <li :class="[{ active: currentActive == 'AI' }]"
                    @click=" currentActive = 'AI'">
                  <img v-if="currentActive === 'AI'"
                       src="../icon/AI-selected.png" />
                  <img v-else
                       src="../icon/AI.png" />
                  <p :class="currentActive === 'AI' ? 'aside-title-selected' : ''">{{
                    $t('CustomSpus.CustomSpuDesigner.AI') }}</p>
                </li>
                <li :class="[{ active: currentActive == 'dss' }]"
                    @click=" currentActive = 'dss'">
                  <img v-if="currentActive === 'dss'"
                       src="../icon/dss-selected.png" />
                  <img v-else
                       src="../icon/dss.png" />
                  <p :class="currentActive === 'dss' ? 'aside-title-selected' : ''">{{
                    $t('CustomSpus.CustomSpuDesigner.works') }}</p>
                </li>
              </ul>
            </div>
            <!-- 创建商品 -->
            <div class="myDesign-components">
              <CreateItem v-if="currentActive === 'design' && productDetailVisible"
                          v-model:selectedColors="selectedColors"
                          container-id="itemId"
                          :class="tutorialSteps === 2 ? 'tutorial-show' : ''"
                          :spu="currentSpu"
                          :colors="availableColors"
                          :is-area-customized="isAreaCustomized"
                          :current-custom-area-scale="currentCustomAreaScale!"
                          @add-custom-text="addCustomText"
                          @change-custom-spu-name="changeCustomSpuName" />
              <!-- 素材库 -->
              <MaterialLibrary v-if="currentActive === 'material'"
                               v-model="currentActive"
                               :current-spu="currentSpu"
                               @changes="uploadImage" />
              <!-- 上传 -->
              <UpLoadImage v-if="currentActive === 'upload'"
                           :is-login="isLogin"
                           @to-login="login"
                           @changes="uploadImage" />
              <!-- AI -->
              <AI v-if="currentActive === 'AI'"
                  :is-login="isLogin"
                  :params-img="!route.params.image"
                  :class="tutorialSteps === 3 ? 'tutorial-show' : ''"
                  @img-no-finished="imgNoFinished"
                  @to-login="login"
                  @changes="uploadImage" />
              <DesignShare v-if="currentActive === 'dss'"
                           v-model="currentActive"
                           :is-login="(isLogin as boolean)"
                           :is-editable="oneditable()"
                           :is-customized="(currentEditingImage?.fabric?.isCustomized() || false)"
                           @to-login="login"
                           @is-buy-whole-set="onBuyWholeSet"
                           @on-selectd-dss="onSelectdDss" />
              <div class="complete">
                <a-button v-if="!currentCustomSpuData.customSpu"
                          :class="['complete-button', tutorialSteps === 4 ? 'tutorial-show' : '']"
                          :disabled="!isCustomized"
                          type="primary"
                          @click="complete">{{ $t('CustomSpus.CustomSpuDesigner.complete') }}</a-button>
                <div v-else
                     class="recustomize">
                  <a-button class="complete-cover"
                            :disabled="(!isAreaCustomized.length)"
                            type="primary"
                            @click="complete">{{ $t('CustomSpus.CustomSpuDesigner.saveDesign') }}
                    <a-tooltip>
                      <template #title>{{ $t('CustomSpus.CustomSpuDesigner.saveDesignTooltip') }}</template>
                      <QuestionCircleOutlined class="color-grey" />
                    </a-tooltip>
                  </a-button>
                  <a-popconfirm :title="$t('CustomSpus.CustomSpuDesigner.coverDesignPopconfirm')"
                                ok-text="Yes"
                                cancel-text="No"
                                @confirm="cover">
                    <a-button class="complete-cover"
                              :disabled="(!isAreaCustomized.length) || !isOrderOfCustom"
                              type="primary">{{ $t('CustomSpus.CustomSpuDesigner.coverDesign') }}
                      <a-tooltip>
                        <template #title>{{ $t('CustomSpus.CustomSpuDesigner.coverDesignTooltip') }}</template>
                        <QuestionCircleOutlined class="color-grey" />
                      </a-tooltip>
                    </a-button>
                  </a-popconfirm>
                </div>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="custom-images">
        <div class="custom-select">
          <div class="custom-area">
            <template v-for="item in editingImages"
                      :key="item.image.id">
              <a-button class="custom-item"
                        :style="item.image.id === currentEditingImage?.image.id ? 'background:black;color:white;' : 'color:#999999;'"
                        @click="onSelect(item)">{{
                          item.image.name[0]
                        }}</a-button>
            </template>
          </div>
          <div class="custom-scale">
            <template v-for="(item, index) in currentEditingImage?.image.scales"
                      :key="index">
              <a-button class="custom-item"
                        :style="item.title === calcCustomScale(currentEditingImage?.image.id!)?.title ? 'background:black;color:white;' : 'color:#999999;'"
                        @click="selectFloatScale(item)">{{
                          item.title[0]
                        }}</a-button></template>
          </div>
        </div>
        <div ref="editorContainer"
             class="editors">
          <a-spin :spinning="customImgLoading || savingLoading || segmentedLoading"
                  :tip="customImgLoading ? $t('CustomSpus.CustomSpuDesigner.painting') : savingLoading ? $t('CustomSpus.CustomSpuDesigner.framing') : $t('CustomSpus.CustomSpuDesigner.cutting')"
                  size="large">
            <ImageCustomizeEditor v-for="item in editingImages"
                                  :id="item.image.id + ''"
                                  :ref="(el: any) => (item.fabric = el)"
                                  :key="item.image.id"
                                  :class="currentEditingImage?.image.id !== item.image.id ? 'hidden' : ''"
                                  :customized-area-scale="calcCustomScale(item.image.id)?.customized_areas_scale || 1"
                                  :container="editorContainerDom"
                                  :template-basic-parameters="templateBasicParameters(toUrl(findCustomableImage(currentColor as Color, item.image))!, currentColor?.value!, item.image.width, item.image.height)"
                                  :custom-area="assignCustomArea(item)"
                                  :default-font="defaultFont"
                                  :destroy-canvas="destroyCanvas"
                                  mode="edit"
                                  @img-loading="imgLoading"
                                  @custom-active-object="activeObject"
                                  @ready="item.onReady"
                                  @customized="onCustomized"
                                  @drag-drop="dragDrop"
                                  @mouseup="() => update3d(item)" />
          </a-spin>
        </div>
        <!-- 颜色块 -->
        <div class="color-list">
          <div v-for="color in selectedColors"
               :key="color.value"
               class="color-item-border">
            <a-tooltip>
              <template #title>{{ color.name }}</template>
              <a-avatar :class="['color-item', currentColor?.value === color.value ? 'selected-color' : '']"
                        shape="square"
                        :alt='color.name'
                        :style="[color.image ? `backgroundImage:url(${color.image})` : '', `backgroundColor:${color.value}`]"
                        @click="onSelectColor(color)">
              </a-avatar>
            </a-tooltip>
          </div>
        </div>
        <div :class="['chatWoot', tutorialSteps === 5 ? 'tutorial-show' : '']">
          <customerService />
        </div>
      </div>
      <div class="preview">
        <CustomEdit :three-dimensional-models-info="threeDimensionalModelsInfo[0]"
                    :canvas-active-object="canvasActiveObject!"
                    :background-color="currentColor?.value || '#fffffff'"
                    :segment-img="segmentImg"
                    :re-create="oneditable()"
                    @img-loading="imgLoading"
                    @replace-img="replaceImg"
                    @three-dimensionalmodal-visible="onPreview"
                    @on-default-font="onDefaultFont"
                    @on-custom-area-adjustment="onCustomAreaAdjustment"></CustomEdit>
      </div>
      <a-modal v-model:visible="modalVisible"
               :destroy-on-close="true"
               :footer="null"
               :title="$t('CustomSpus.CustomSpuDesigner.preview3D')">
        <a-carousel effect="fade"
                    arrows>
          <template #prevArrow>
            <div class="custom-slick-arrow"
                 style="left: 10px; z-index: 1">
              <left-circle-outlined />
            </div>
          </template>
          <template #nextArrow>
            <div class="custom-slick-arrow"
                 style="right: 10px">
              <right-circle-outlined />
            </div>
          </template>
          <div v-for="(item, index) in threeDimensionalModelsInfo"
               :key="index">
            <div class="modelPreview">
              <ThreeDimensional :label-by-id='`preview${index}`'
                                :background-color="currentColor?.value || '#fffffff'"
                                draco-url="/assets/js/drco/gltf/"
                                :three-dimensional-model-info="item" />
            </div>
          </div>
        </a-carousel>
      </a-modal>
    </div>
    <a-modal v-model:visible="loginVisible"
             wrap-class-name="fb_designer_modal_wrap"
             class="fb_designer_modal"
             :footer="null"
             :width="500">
      <FlashbaseSystemLogo />
      <iota-simple-signin :options="{ newWindowToResetPassword: true }"
                          @success="loginSuccess"></iota-simple-signin>
    </a-modal>
    <div v-if="tutorialSteps"
         class="tutorial">
      <div :class="['tutorial-step', tutorialStepClass[tutorialSteps - 1]]">
        ```vue
        <div class="tutorial-step-title">
          <img src="../icon/tutorial-arrow.png">
          <p v-show="tutorialSteps === 1">{{ $t('CustomSpus.CustomSpuDesigner.tutorialStep1') }}</p>
          <p v-show="tutorialSteps === 2">{{ $t('CustomSpus.CustomSpuDesigner.tutorialStep2') }}</p>
          <p v-show="tutorialSteps === 3">{{ $t('CustomSpus.CustomSpuDesigner.tutorialStep3') }}</p>
          <p v-show="tutorialSteps === 4">{{ $t('CustomSpus.CustomSpuDesigner.tutorialStep4') }}</p>
          <p v-show="tutorialSteps === 5">{{ $t('CustomSpus.CustomSpuDesigner.tutorialStep5') }}</p>
        </div>
        <div v-if="tutorialSteps != tutorialStepClass.length"
             class="tutorial-step-button">
          <p @click="tutorialSteps = 0">{{ $t('CustomSpus.CustomSpuDesigner.skip') }}</p>
          <a-button class="button"
                    @click="tutorialSteps++">{{ $t('CustomSpus.CustomSpuDesigner.nextStep') }}</a-button>
        </div>
        <div v-else
             class="tutorial-step-button">
          <a-button class="button"
                    @click="tutorialSteps++">{{ $t('CustomSpus.CustomSpuDesigner.gotIt') }}</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toUrl } from "@/utils"
import { ThreeDimensional, ImageCustomizeEditor } from '@iota-cn/ui-components'
import { computed, onMounted, ref, watch, onUnmounted } from 'vue'
// import ThreeDimensional from "./ThreeDimensional.vue"
import customerService from "./CustomerService.vue"
import { useRoute, useRouter } from 'vue-router'
import { categories, categoriesDetail } from '../../home/api/index'
import { getCustomSpu, submitCustomSpu, uploadCustomImage, updateCustomSpu, fetchOrderOfCustomSpu } from '../api/index'
import { EditingImage, type Color, type CustomizedAreasScale, type CustomizedImage, type SelectedDssThemeList, type CustomPrice, type DssCustomizedImage, type Technology, type NewCustomSpu, type BuyDssTheme, type Spu, type ThreeDimensionalModelInfo } from '../types'
import { findCustomableImage, templateBasicParameters, convertImageAndColor } from "../utils"
import CreateItem from './components/CreateItemPages.vue'
import CustomEdit from "./components/CustomEdit.vue"
import type { UserService } from '@/core'
import { CORE_USER } from '@/core/CoreSymbol'
import type { LoginPageOption, LoginPageService, Plugin } from '@/plugins'
import { PLUGIN_AUTH } from '@/plugins/builtin/BuiltinPluginSymbol'
import Cookie from 'js-cookie'
import { container } from 'tsyringe'
import type { categoriesMenusState } from "../../shop/api/interface/categoriesInterface"
import MaterialLibrary from './components/MaterialLibraryPages.vue'
import AI from './components/AI.vue'
import DesignShare from './components/DesignShare.vue'
import UpLoadImage from './components/UpLoadImage.vue'
import { selectedSpuData } from "../../index"
import { message } from "ant-design-vue"
import BigNumber from "bignumber.js"
import { useI18n } from 'vue-i18n'
BigNumber.config({ ROUNDING_MODE: 1 })
const isCustomized = ref<boolean>(false)
const isAreaCustomized = ref<CustomPrice[]>([])
const currentCustomAreaScale = ref<CustomizedAreasScale[]>([])
const selectedDssThemeList = ref<SelectedDssThemeList[]>([])
const isLogin = computed(() => {
  const userService = container.resolve<UserService>(CORE_USER)
  const loginOptions = container.resolve<Plugin<LoginPageOption, LoginPageService>>(PLUGIN_AUTH)
  const isUserValid = userService.isUserValid()
  const cookie = Cookie.get(loginOptions.options.cookieKey || 'iota')
  const isLogged = isUserValid && cookie && cookie.length > 0
  return isLogged
})
const segmentedLoading = ref<boolean>(false)
const segmentImg = ref<string>('')
const isOrderOfCustom = ref<boolean>(false)
const currentCustomSpuName = ref<string>('')
const tutorialStepClass = ref<string[]>(['tutorial-step-first', 'tutorial-step-second', 'tutorial-step-third', 'tutorial-step-fourth', 'tutorial-step-fifth'])
const customImgLoading = ref<boolean>(false)
const savingLoading = ref<boolean>(false)
const currentCustomSpuData = selectedSpuData()
const currentCustomSpuDataJson = currentCustomSpuData.pathJudgment()
const tutorialSteps = ref<number>(0)
const defaultFont = ref<'SimSun' | 'PingFang SC'>()
const canvasActiveObject = ref<object>()
const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const categoryId = ref<string>(route.query.categoryId as any ?? 0)
const spuId = ref<string>(route.query.spuId as any ?? 0)
const threeDimensionalModelsInfo = ref<Array<ThreeDimensionalModelInfo>>([])
const modalVisible = ref<boolean>(false)
const productDetailVisible = ref<boolean>(false)
const loginVisible = ref<boolean>(false)
const currentActive = ref<'design' | 'material' | 'upload' | 'AI' | 'dss'>('design')
const spuModel = ref<Spu>()
const currentSpu = ref<Spu>()
const editingImages = ref<EditingImage[]>([])
const productArray = ref<categoriesMenusState['categories'] | any>()
const activeKey = ref('2')
const destroyCanvas = ref<boolean>(false)
/**
 *组件变量
 */
const currentEditingImage = ref<EditingImage>()

/**
 *颜色
 */
const availableColors = ref<Color[]>([])
const selectedColors = ref<Color[]>([])
const currentColor = ref<Color>()
const editorContainer = ref()
const editorContainerDom = computed(() => {
  return editorContainer.value
})

watch(() => tutorialSteps.value, () => {
  if (tutorialStepClass.value[tutorialSteps.value - 1] === 'tutorial-step-third')
    currentActive.value = 'AI'
  else
    currentActive.value = 'design'

  if (!tutorialSteps.value || tutorialSteps.value > tutorialStepClass.value.length) {
    tutorialSteps.value = 0
    localStorage.setItem('isTutorialReaded', 'true')
  }
})

watch(selectedColors, (newColors) => {
  currentColor.value = newColors[newColors.length - 1]
}, { deep: true })

watch(() => activeKey.value, () => {
  if (activeKey.value === '1') {
    productArray.value.forEach((item: any) => {
      if (item.list)
        return
      categoriesDetail(item.id as number).then(result => {
        if (result.spus.length > 0) {
          item.list = result.spus
        }
      })
    })
  }
})

// 图片切换
const onSelect = (image: EditingImage) => {
  currentEditingImage.value = image
  canvasActiveObject.value = currentEditingImage.value?.fabric.currentSelectionActiveObject()
  const info = threeDimensionalModelsInfo.value
  info?.forEach((r: any) => {
    const relevanceNode = r.relevanceNodes.find((res: any) => res.customImageId == image.image.id)
    if (relevanceNode) {
      if (!r.relevanceSwatch.find((result: any) => result.currentLocation == relevanceNode.node)) {
        r.relevanceSwatch.push({
          currentLocation: relevanceNode.node,
          texture: '',
          customImageId: relevanceNode.customImageId
        })
      }
    }
  })
}

const oneditable = () => {
  if (selectedDssThemeList.value.length) {
    const existingEditingIndex = selectedDssThemeList.value.findIndex((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
    if (existingEditingIndex >= 0) {
      return (!!selectedDssThemeList.value[existingEditingIndex]?.buyDssThemeList.find((r: BuyDssTheme) => r.dsstheme?.shareable) && currentEditingImage.value?.fabric.isCustomized()) || false
    } else {
      return true
    }
  } else
    return true
}

const replaceImg = (imgUrl: string) => {
  segmentedLoading.value = true
  currentEditingImage.value?.fabric.replaceImg(imgUrl)
}

const assignCustomArea = (item: any) => {
  return Object.assign({}, item.image.custom_areas, { json: item.json })
}

const dragDrop = (operation: string, value: boolean) => {
  if (operation === 'scaling') {
    currentCustomSpuData.customAreaAdjustment.maximize = value
    currentCustomSpuData.customAreaAdjustment.spreadOut = value
    currentCustomSpuData.customAreaAdjustment.heightMaximization = value
    currentCustomSpuData.customAreaAdjustment.widthMaximization = value
  } else if (operation === 'flipHorizontal') {
    currentCustomSpuData.customAreaAdjustment.flipHorizontal = value
  } else {
    currentCustomSpuData.customAreaAdjustment.flipVertical = value
  }
}

const imgLoading = (loading: boolean) => {
  customImgLoading.value = loading
}

const activeObject = (selected: any, segmentImgUrl?: string) => {
  if (segmentImgUrl)
    segmentImg.value = segmentImgUrl
  else
    segmentImg.value = ''

  canvasActiveObject.value = selected
  segmentedLoading.value = false
}

const changeCustomSpuName = (value: string) => {
  currentCustomSpuName.value = value
}

const temporaryMaterial = computed(() => {
  let materialFilter: any = false
  productArray.value.forEach((item: any) => {
    if (item.list && item.list.length > 0) {
      item?.list.forEach((itm: any) => {
        materialFilter = itm.attrs.find((i: any) => {
          return i.attribute.key == 'material'
        })
      })
    }
  })
  return materialFilter?.value
})

const login = () => {
  loginVisible.value = true
}

const designClick = () => {
  router.push('/console/products/spus')
}

const onSelectColor = (color: Color) => {
  currentColor.value = color
}

const onDefaultFont = (value: 'SimSun' | 'PingFang SC') => {
  defaultFont.value = value
}

const onPreview = (value: boolean) => {
  modalVisible.value = value
}

const addCustomText = () => {
  if (!oneditable()) {
    message.error(t('CustomSpus.CustomSpuDesigner.noRedesign'))
  } else {
    currentEditingImage.value?.fabric.addTextToCustomArea(t('CustomSpus.CustomSpuDesigner.doubleClickToEdit'))
    setTimeout(() => {
      update3d(currentEditingImage.value as EditingImage)
    }, 300)
  }
}

const onBuyWholeSet = (buyDssTheme: BuyDssTheme) => {
  const existingEditing = selectedDssThemeList.value.find((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
  const currentAreaCustomized = isAreaCustomized.value.find((r: CustomPrice) => r.name === currentEditingImage.value?.image.name)
  if (existingEditing) {
    existingEditing.buyDssThemeList.forEach((r: BuyDssTheme) => {
      if (r.dsstheme?.id === buyDssTheme.dsstheme?.id) {
        r.buyWholeSet = true
        r.selectedCustomizedImages.forEach((res: DssCustomizedImage) => {
          if (currentAreaCustomized && currentAreaCustomized.dss_image_price) {
            currentAreaCustomized.dss_image_price = new BigNumber(currentAreaCustomized.dss_image_price).minus(res.ref_price).toFixed(2)
          }
        })
      }
    })
  }
}

const onSelectdDss = (buyDssTheme: BuyDssTheme) => {
  buyDssTheme.selectedCustomizedImages.forEach(async (r: DssCustomizedImage) => {
    await uploadImage(toUrl(r.image)!)
  })
  const existingEditingIndex = selectedDssThemeList.value.findIndex((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
  if (existingEditingIndex >= 0) {
    selectedDssThemeList.value[existingEditingIndex].buyDssThemeList.push(buyDssTheme)
  } else {
    selectedDssThemeList.value.push({
      product_spu_customable_image_id: currentEditingImage.value?.image.id,
      buyDssThemeList: [buyDssTheme]
    })
  }
}

/**
 *上传图片
 */
const uploadImage = (image: string) => {
  if (!oneditable()) {
    message.error(t('CustomSpus.CustomSpuDesigner.noRedesign'))
  } else {
    const waitCanvas = setInterval(() => {
      if (currentEditingImage.value && currentEditingImage.value?.fabric) {
        customImgLoading.value = true
        currentEditingImage.value?.fabric.addImageToCustomArea(image)
        update3d(currentEditingImage.value as EditingImage)
        clearInterval(waitCanvas)
      }
    }, 300)
  }
}

onUnmounted(() => {
  destroyCanvas.value = true
})

onMounted(async () => {
  await categories().then(result => {
    productArray.value = result.categories
  }).then(() => {
    // 生成特定产品详情
    if (categoryId.value && spuId.value) initDesignData()
    else {
      productArray.value.forEach(async (item: any) => {
        await categoriesDetail(item.id as number).then(result => {
          if (result.spus.length > 0) {
            item.list = result.spus
            if (!categoryId.value && !spuId.value) {
              // 随机生成产品详情
              categoryId.value = item.list[0].category_id
              spuId.value = item.list[0].id
              initDesignData()
            }
          }
        })
      })
    }
    if (!localStorage.getItem('isTutorialReaded'))
      tutorialSteps.value = 1
  })

  if (route.query.image) {
    currentActive.value = 'AI'
    uploadImage(`${route.query.image}width=800&height=800`)
  }
  if (currentCustomSpuData.$state.customSpu) {
    await fetchOrderOfCustomSpu(currentCustomSpuData.$state.customSpu!.id).then((res: any) => {
      isOrderOfCustom.value = res.isOrderOfCustom
      if (res.isOrderOfCustom)
        message.info(t('CustomSpus.CustomSpuDesigner.noOverwriteProduction'))
    })
  }

})

const productItemClick = async (data: any) => {
  currentSpu.value = data
  selectedColors.value = []
  availableColors.value = convertImageAndColor(data)
  if (availableColors.value.length > 0) {
    if (selectedColors.value.length < 1)
      selectedColors.value.push(availableColors.value[0])
    currentColor.value = availableColors.value[0]
  }
  editingImages.value = (data.customableImages || []).map((i: any) => {
    return new EditingImage(i as CustomizedImage)
  })
  currentEditingImage.value = editingImages.value[0]

  editingImages.value.forEach((r: any) => {
    const currentScale = r.image.scales.find((rr: any) => Number(rr.customized_areas_scale) === 1)
    if (currentScale) {
      currentCustomAreaScale.value.push({
        customable_image_id: r.image?.id,
        discount_amount_scale: currentScale?.discount_amount_scale,
        customized_areas_scale: currentScale?.customized_areas_scale,
        title: currentScale?.title
      })
    } else {
      currentCustomAreaScale.value.push({
        customable_image_id: r.image?.id,
        discount_amount_scale: r.image.scales[0]?.discount_amount_scale,
        customized_areas_scale: r.image.scales[0]?.customized_areas_scale,
        title: r.image.scales[0]?.title
      })
    }
  })
  getModelInfo(currentSpu.value)
  canvasActiveObject.value = undefined
  productDetailVisibleFunc(true)
}

const initDesignData = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res: any = await getCustomSpu(categoryId.value, spuId.value)
  const spu: Spu = res as Spu
  spu.attrs = spu.attrs || []
  availableColors.value = convertImageAndColor(res)
  currentSpu.value = spu
  editingImages.value = (spu?.customableImages || []).map((i) => {
    return new EditingImage(i as CustomizedImage)
  })
  currentEditingImage.value = editingImages.value[0]

  if (currentCustomSpuDataJson) {
    currentCustomSpuName.value = currentCustomSpuDataJson.name
    currentCustomAreaScale.value = currentCustomSpuDataJson.price_detail.custom_price!.map((r: any) => {
      return {
        customable_image_id: r.id,
        customized_areas_scale: r.customized_areas_scale,
        discount_amount_scale: r.discount_amount_scale,
        title: r.customized_areas_scale_title
      }
    })

    isAreaCustomized.value = currentCustomSpuDataJson.price_detail.custom_price!

    const rawData: Color[] = []
    currentCustomSpuDataJson.customSkus.forEach((r: any) => rawData.push(r.color))
    rawData.forEach((r: any) => {
      if (!selectedColors.value.find((rr: any) => rr.name === r.name))
        selectedColors.value.push(r)
    })

    editingImages.value.forEach((r: any) => {
      const currentJson = currentCustomSpuDataJson.customizedImages.find((rr: any) => rr.customableImage.id === r.image.id)?.customized_json
      if (currentJson) r.json = currentJson
    })

    currentColor.value = selectedColors.value.find((r: any) => r.value === currentCustomSpuDataJson!.customizedImages[0].customized_json.background)
  } else {
    editingImages.value.forEach((r: any) => {
      const currentScale = r.image.scales.find((rr: any) => Number(rr.customized_areas_scale) === 1)

      if (currentScale) {
        currentCustomAreaScale.value.push({
          customable_image_id: r.image.id,
          discount_amount_scale: currentScale.discount_amount_scale,
          customized_areas_scale: currentScale.customized_areas_scale,
          title: currentScale.title
        })
      } else {
        currentCustomAreaScale.value.push({
          customable_image_id: r.image.id,
          discount_amount_scale: r.image.scales.length ? r.image.scales[0].discount_amount_scale : 1,
          customized_areas_scale: r.image.scales.length ? r.image.scales[0].customized_areas_scale : 1,
          title: r.image.scales.length ? r.image.scales[0].title : '默认'
        })
      }
      if (availableColors.value.length > 0) {
        if (selectedColors.value.length < 1)
          selectedColors.value.push(availableColors.value[0])
        currentColor.value = availableColors.value[0]
      }
    })
  }

  getModelInfo(res)
  categories().then(result => {
    productArray.value = result.categories
  })

  if (currentSpu.value) {
    productDetailVisibleFunc(true)
  }
}

const getModelInfo = (spuValue: any) => {
  threeDimensionalModelsInfo.value = []
  setTimeout(() => {
    spuModel.value = spuValue
    spuValue?.threeDimensional.forEach((item: any) => {
      const swatch = item.corresponding.find((r: any) => r.customImageId == currentEditingImage.value?.image.id)
      const prestore = {
        relevanceNodes: item.corresponding,
        relevanceSwatch: [{
          currentLocation: swatch.node,
          texture: '',
          customImageId: swatch.customImageId
        }],
        url: toUrl(item.model)!,
        preview: item.preview
      }
      if (item.preview) {
        threeDimensionalModelsInfo.value.unshift(prestore)
      } else {
        threeDimensionalModelsInfo.value.push(prestore)
      }
    })
  }, 0)
}

const judgmentSelectProduct = () => {
  if (!currentCustomSpuData.customSpu)
    activeKey.value = '1'
  else
    message.info(t('CustomSpus.CustomSpuDesigner.cannotChangeProduct'))
}

const nologin = () => {
  const userService = container.resolve<UserService>(CORE_USER)
  const user = userService.getUser()
  if (Object.entries(user.value).length < 1) {
    loginSuccess()
    return true
  }
  return false
}

const createCustomSpu = async () => {
  if (nologin()) {
    return new Promise((resolve, reject) => {
      reject(t('CustomSpus.CustomSpuDesigner.notLoggedIn'))
    })
  }

  const customSpu: NewCustomSpu = { spu_id: 0, colors: [], name: '', customizedImages: [] }
  customSpu.spu_id = currentSpu.value?.id
  customSpu.colors = selectedColors.value
  customSpu.name = currentCustomSpuName.value
  customSpu.price = currentSpu.value?.price || 0
  if (customSpu.name === '')
    customSpu.name = currentSpu.value?.name

  const imgPromises: Array<Promise<string>>[] = []
  editingImages.value.forEach((element) => {
    if (element.fabric.isCustomized()) {
      const custom = {
        custom_area_id: element.image.custom_areas.id,
        spu_customable_image_id: element.image.id,
        customized_image: '',
        customized_json: {},
        customized_areas: { customable_image_scale: element.image.custom_areas.scale || 2, customized_areas_scale: 1, discount_amount_scale: 1, boundingRect: {} },
      }
      const currentScale = currentCustomAreaScale.value.find((r: any) => r.customable_image_id === element.image.id)
      custom.customized_areas.customized_areas_scale = currentScale!.customized_areas_scale
      custom.customized_areas.discount_amount_scale = currentScale!.discount_amount_scale
      customSpu.customizedImages?.push(custom)
      imgPromises.push(element.fabric.exportVisualCustomAreaImageAsBlobAsync().then((
        { blob, boundingRect }: { blob: Blob, boundingRect: { left: number, top: number, width: number, height: number } }
      ) => {
        custom.customized_areas.boundingRect = boundingRect
        return uploadCustomImage(blob).then((image: string) => {
          custom.customized_image = image
          custom.customized_json = element.fabric.exportCustomAreaJson()
        }).catch((res: any) => {
          if (res.detail === "unsupported size")
            message.error(t('CustomSpus.CustomSpuDesigner.designTooLarge'))
          else
            message.error(t('CustomSpus.CustomSpuDesigner.designNotCompliant'))
        })
      }))
    }
  })
  await Promise.all(imgPromises)
  return customSpu
}

const complete = async () => {
  savingLoading.value = true
  createCustomSpu().then(async (customSpu) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customSpuData = Object.assign(customSpu!, { selectedDssThemeList: selectedDssThemeList.value })
    const res: any = await submitCustomSpu(customSpuData)
    router.push(`/console/products/custom_spus/${res.id}`)
    savingLoading.value = false
  }).catch((error: any) => {
    message.error(typeof error === 'string' && error || error.message)
    savingLoading.value = false
  })
}

const cover = async () => {
  savingLoading.value = true
  createCustomSpu().then(async (customSpu) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await updateCustomSpu(customSpu as NewCustomSpu, currentCustomSpuDataJson?.id as any)
    router.push(`/console/products/custom_spus/${currentCustomSpuDataJson?.id}`)
  })
  savingLoading.value = false
}

const calcCustomScale = (image_id: number) => {
  return currentCustomAreaScale.value.find((r: any) => r.customable_image_id === image_id)
}

const update3d = (element: EditingImage) => {
  // if (!threeDimensionalModelsInfo.value.length)
  //   return
  // todo 直接return会导致图片edit看不见
  // const info = threeDimensionalModelsInfo.value
  // element?.fabric.exportCustomAreaImageAsImageDataAsync().then((
  //   img: ImageData
  // ) => {
  //   info.forEach((r: any) => {
  //     r.value
  //   })
  //   threeDimensionalModelsInfo.value.forEach((r: any) => {
  //     const temp = r.relevanceSwatch.find((res: any) => res.customImageId == currentEditingImage.value?.image.id)
  //     if (temp) {
  //       temp.texture = img
  //     }
  //   })
  // }).catch((err: any) => {
  //   console.log(err)
  // })
}

const imgNoFinished = () => {
  currentActive.value = 'AI'
  message.info(t('CustomSpus.CustomSpuDesigner.unfinishedImages'))
}

const onCustomAreaAdjustment = (adjustment: any) => {
  if (!currentEditingImage.value)
    return

  currentEditingImage.value?.fabric.updateCustomArea(adjustment)
  setTimeout(() => {
    update3d(currentEditingImage.value as EditingImage)
  }, 300)
}

const selectFloatScale = (scale: any) => {
  const currentScale = calcCustomScale(currentEditingImage.value?.image.id!)
  if (!currentScale)
    return

  currentScale.title = scale.title
  currentScale.customized_areas_scale = scale.customized_areas_scale
  currentScale.discount_amount_scale = scale.discount_amount_scale

  if (!isAreaCustomized.value.length)
    return

  const discountScale = isAreaCustomized.value.find((r) => r.name === currentEditingImage.value?.image.name)
  discountScale!.customized_areas_scale = scale.customized_areas_scale
  discountScale!.discount_amount_scale = scale.discount_amount_scale
  discountScale!.customized_areas_scale_title = scale.title
}

const onCustomized = (deleteUrl?: String) => {
  if (!currentEditingImage.value)
    return

  const currentScale = calcCustomScale(currentEditingImage.value?.image.id!)

  if (!currentScale)
    return
  let existenceCustomization = false
  editingImages.value.forEach(r => {
    if (r.fabric.isCustomized())
      existenceCustomization = true
  })
  const findCurrentEditingIndex = isAreaCustomized.value.findIndex((r: CustomPrice) => r.name === currentEditingImage.value?.image.name)
  const existingEditingIndex = selectedDssThemeList.value.findIndex((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
  if (existenceCustomization) {
    let calcDssImagePrice = '0'
    if (existingEditingIndex >= 0) {
      selectedDssThemeList.value[existingEditingIndex].buyDssThemeList.forEach((res: BuyDssTheme) => {
        if (res.dsstheme?.type != '1' && res.dsstheme?.type != '2' && !res.dsstheme?.free) {
          res.selectedCustomizedImages.forEach((r: DssCustomizedImage) => {
            calcDssImagePrice = new BigNumber(calcDssImagePrice).plus(r.ref_price).toFixed(2)
          })
        }
      })
    }
    if (findCurrentEditingIndex === -1) {
      let minTechnologyPrice = {
        id: 0,
        name: '',
        price: 0
      } as Technology
      if (currentEditingImage.value?.image.technologies?.length) {
        minTechnologyPrice = currentEditingImage.value?.image.technologies[0]
        currentEditingImage.value?.image.technologies.forEach((r: Technology) => {
          if (minTechnologyPrice.price > r.price)
            minTechnologyPrice = r
        })
      }
      const data: {
        name: string
        price: string
        discount_amount_scale: string
        customized_areas_scale: string
        customized_areas_scale_title: string
        technology: Technology
        dss_image_price?: string
      } = {
        name: currentEditingImage.value.image.name,
        price: currentEditingImage.value.image.price.toString(),
        discount_amount_scale: currentScale?.discount_amount_scale.toString(),
        customized_areas_scale: currentScale?.customized_areas_scale.toString(),
        customized_areas_scale_title: currentScale?.title,
        technology: minTechnologyPrice
      }
      if (calcDssImagePrice != '0') {
        data.dss_image_price = calcDssImagePrice
      }
      isAreaCustomized.value?.push(data)
    } else {
      isAreaCustomized.value[findCurrentEditingIndex].dss_image_price = calcDssImagePrice
    }
  } else {
    const tempIndex = isAreaCustomized.value.findIndex((r: CustomPrice) => r.name === currentEditingImage.value?.image.name)
    isAreaCustomized.value.splice(tempIndex, 1)
  }
  setTimeout(() => {
    update3d(currentEditingImage.value as EditingImage)
  }, 300)
  canvasActiveObject.value = undefined
  if (deleteUrl && selectedDssThemeList.value.length) {
    const currentSelectedImgs = selectedDssThemeList.value[existingEditingIndex].buyDssThemeList
    currentSelectedImgs.forEach((r: BuyDssTheme) => {
      const deleteImgIndex = r.selectedCustomizedImages.findIndex((res: DssCustomizedImage) => res.image === deleteUrl)
      if (deleteImgIndex >= 0) {
        if (isAreaCustomized.value[findCurrentEditingIndex]?.dss_image_price) {
          isAreaCustomized.value[findCurrentEditingIndex].dss_image_price = new BigNumber(isAreaCustomized.value[findCurrentEditingIndex].dss_image_price!).minus(r.selectedCustomizedImages[deleteImgIndex].ref_price).toFixed(2)
        }
        r.selectedCustomizedImages.splice(deleteImgIndex, 1)
      }
    })
    if (currentSelectedImgs[0].selectedCustomizedImages.length === 0) {
      selectedDssThemeList.value.splice(existingEditingIndex, 1)
    }
    oneditable()
  }
  isCustomized.value = false
  editingImages.value.forEach((r: any, i: number) => {
    if (r.fabric.isCustomized()) {
      isCustomized.value = true
    }
  })
}

const productDetailVisibleFunc = (switchField: boolean) => {
  productDetailVisible.value = switchField
}

const loginSuccess = () => {
  loginVisible.value = !loginVisible.value
}
</script>
<style scoped lang="less">
.modelPreview {
  width: 100%;
  height: 50vh;
}

.itemDetail {
  width: 220px;
  height: 450px;
  overflow-y: auto;

  img {
    width: 100%;
    height: 200px;
  }

  .title {
    margin-top: 10px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .detail-txt {
    span:first-child {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FAAD14;
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span:not(:first-child) {
      float: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4500);
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.custom-spu-designer-content {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column;
  position: relative;
  overflow: hidden;


  :deep(.ant-tabs-tab) {
    height: 46px;
    width: 195px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }

  :deep(.ant-tabs-top > .ant-tabs-nav) {
    margin: 0;
  }

  :deep(.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn) {
    z-index: 999;
    font-size: 16px;
    font-weight: 400;
    color: #111111 !important;
  }

  :deep(.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap) {
    transform: none;
  }

  :deep(.ant-tabs-nav-list) {
    transform: none !important;
  }

  :deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab) {
    border: none;
  }

  .ant-carousel :deep(.slick-slide) {
    text-align: center;
    height: 50vh;
    background: #364d79;
    overflow: hidden;
  }


  .design-top {
    z-index: 999;
    cursor: pointer;
    height: 50px;
    width: 100vw;
    background-image: url(../icon/design-top.png);
    display: flex;
    position: relative;

    .user {
      height: 100%;
      position: absolute;
      right: 30px;
      display: flex;
      align-items: center;

      .login-btn {
        margin-top: 5px;
        color: #fff;
        width: 98px;
        height: 40px;
        background: #00000000;
      }

      :deep(.username) {
        min-width: 60px;
        width: 100%;
        max-width: 20vw;
        color: white;
      }
    }

    // .user-login {
    //   margin-top: 15px;
    // }
    .logo-icon {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .logo {
        width: 222px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }


    .back-icon {
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .back {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 24px;
        border: 1px solid #99999976;
        color: #99999988;

        img {
          width: 13px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .designer {
    flex: 1;
    width: 100vw;
    display: flex;
    justify-content: space-between;
    background: #f6f6f9;
    overflow: hidden;

    :deep(.ant-tabs-content) {
      height: 100%;
    }

    :deep(.ant-tabs-content-holder) {
      height: 100%;
      flex: 1;
    }

    :deep(.ant-tabs) {
      height: 100%;
    }

    .tab-pane {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 390px;
      height: 50px;
      cursor: pointer;


      .tab {
        width: 195px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .select {
        background: #F1F1F1;
        font-size: 16px;
        font-family: 'Microsoft YaHei';
        font-weight: 400;
        color: #999999;
      }

      .selected {
        background: #FFFFFF;
        font-size: 16px;
        font-family: 'Microsoft YaHei';
        font-weight: 400;
        color: #111111;
      }
    }

    .myDesign {
      height: 100%;
      flex: 1;
      display: flex;
      position: relative;

      .myDesign-components {
        display: flex;
        flex-flow: column;
        justify-content: space-around;
      }

      .complete {
        z-index: 999;
        height: 5%;
        position: absolute;
        bottom: 0;
        flex: 1;
        background: white;
        padding-left: 20px;

        .complete-button {
          width: 260px;
          height: 40px;
          color: white;
          background: #111111;
        }

        .recustomize {
          display: flex;
          justify-content: space-between;


          .complete-cover {
            margin: 0 5px;
            width: 130px;
            height: 40px;
            color: black;
            background: white;
          }
        }
      }

      .asideMenu {
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
        background-color: #f0f2f5;

        ul {
          font-size: 16px;
          text-align: center;

          li {
            cursor: pointer;
            width: 90px;
            height: 84px;
            padding-top: 14px;

            img {
              width: 28px;
            }

            p {
              font-size: 16px;
              font-weight: 400;
              color: #999999;
            }

            .aside-title-selected {
              color: #111111;
            }
          }

          .active {
            background-color: #ffffff
          }
        }
      }
    }

    .custom-images {
      display: flex;
      position: relative;
      justify-content: space-between;
      padding: 20px;
      flex: 1;
      flex-direction: column;
      overflow: hidden;


      .custom-select {
        display: flex;
        padding: 10px;

        .custom-area {
          margin-right: 20px;
        }

        .custom-item {
          margin-bottom: 5px;
          width: 68px;
          height: 40px;
          border: none;

          :deep(span) {
            // line-height: 35px;
            width: 100%;
          }
        }
      }

      .editors {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        overflow: hidden;

        :deep(.ant-spin-nested-loading > div > .ant-spin) {
          top: 50%;
          max-height: 0;
        }

        .hidden {
          display: none;
        }
      }

      .color-list {
        position: absolute;
        right: 20px;
        top: 20px;
        display: flex;
        flex-direction: column;

        .color-item-border {
          min-height: 36px !important;
          min-width: 36px !important;
          margin-bottom: 10px;
          align-items: center;
          display: flex;
          justify-content: space-around;
          border: 1px solid rgb(215, 215, 215);

          .color-item {
            background-size: 100%;
            min-height: 36px !important;
            min-width: 36px !important;
          }

          .selected-color {
            border: 1px solid black;
          }
        }
      }

      .chatWoot {
        position: absolute;
        right: 25px;
        bottom: 25px;
        height: 50px;
        width: 50px;
      }
    }

    .preview {
      width: 300px;
      position: relative;
    }

    .content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px;
    }

    :deep(.ant-tabs-tabpane) {
      display: flex;
    }

    .product-box {
      flex: 1;
      width: 390px;
      overflow: auto;
      background-color: white;
      padding: 15px;

      .product-category {
        font-size: 16px;
        font-weight: 400;
        color: #111111;
      }

      .product-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        .product-item {
          background-color: #F6F6F6;
          width: 110px;
          height: 110px;
          margin-right: 10px;
          margin-bottom: 8px;
          cursor: pointer;

          .product-list-img {
            min-width: 98px;
            min-height: 98px;
            background-size: cover;
          }
        }

        .product-item:nth-child(3n) {
          margin-right: 0px !important;
        }
      }
    }
  }

  :deep(.custom-slick-arrow) {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #a1a3a6;
    transition: ease all 0.3s;
    z-index: 1;
  }

  :deep(.custom-slick-arrow:before) {
    display: none;
  }

  :deep(.custom-slick-arrow:hover) {
    color: black;
    opacity: 0.5;
  }

  :deep(.ant-popover-inner-content) {
    padding: 12px 5px;
  }

  .tutorial {
    z-index: 99;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);

    .tutorial-step-first {
      top: 100px;
      left: 90px;
      background-image: url(../icon/tutorial-01.png);
      background-size: 100% 100%;
    }

    .tutorial-step-second {
      top: 179px;
      left: 414px;
      background-image: url(../icon/tutorial-02.png);
      background-size: 100% 100%;
    }

    .tutorial-step-third {
      top: 179px;
      left: 414px;
      background-image: url(../icon/tutorial-03.png);
      background-size: 100% 100%;
    }

    .tutorial-step-fourth {
      bottom: 90px;
      left: 181px;
      background-image: url(../icon/tutorial-04.png);
      background-size: 100% 100%;
    }

    .tutorial-step-fifth {
      bottom: 90px;
      right: 195px;
      background-image: url(../icon/tutorial-05.png);
      background-size: 100% 100%;
    }


    .tutorial-step {
      width: 308px;
      height: 185px;
      z-index: 9999;
      position: absolute;

      .tutorial-step-title {
        margin-top: 55px;
        margin-left: 20px;
        display: flex;

        img {
          width: 16px;
          height: 16px;
        }

        p {
          width: 240px;
          margin-left: 5px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #111111;
          line-height: 15px;
        }
      }

      .tutorial-step-button {
        float: right;
        display: flex;
        cursor: pointer;

        p {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          margin-top: 40px;
          margin-right: 20px;
        }

        .button {
          margin-top: 30px;
          margin-right: 20px;
          color: #fff;
          width: 68px;
          height: 40px;
          background: #111111;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .tutorial-show {
    z-index: 999;
  }
}
</style>

<style type="less">
.fb_designer_modal_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .fb_designer_modal {
    top: 0;

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      padding: 50px;

      .default-logo {
        width: 110px !important;
        margin: 0 auto !important;
      }

      .ant-tabs-ink-bar {
        bottom: 0;
        height: 4px;
        transform: scaleX(0.5);
      }

      .ant-tabs-tab {
        padding: 0px;
        margin-top: 20px;
        margin-bottom: 10px;

        .ant-tabs-tab-btn {
          font-family: 'SourceHanSansCN-Regular';
        }
      }

      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          font-family: 'SourceHanSansCN-Bold';
        }
      }

      .ant-input-affix-wrapper {
        border: none;
        border-bottom: 1px solid #d9d9d9;
      }

      .ant-input-affix-wrapper:focus {
        box-shadow: none !important;
      }

      .ant-input-affix-wrapper-focused {
        box-shadow: none !important;
      }
    }
  }
}
</style>
